module.exports = __webpack_public_path__ + "media/images/products/cards/carta_do_estrategista-5dc402d50a6b5af85d1d08c44a63d3c8.png";